<template>
  <div>
    <Row>
      <Col span="10">
        <MaterialCategorylist
          :MaterialCategorylist="MaterialCategorylist"
          :MaterialCategoryinfo="MaterialCategoryinfo"
          @MaterialCategorySelectHandleClick="MaterialCategorySelectHandleClick"/>
      </Col>
      <Col span="13" offset="1">
        <PriceRules
          :lists="RulesList"
          :Classification="MaterialCategoryinfo.Classification"
          :CurrentRule="CurrentRule"
          v-if="MaterialCategoryinfo.ClassificationID"
          @PriceRuleSelectHandleClick="PriceRuleSelectHandleClick"/>
      </Col>
    </Row>
    <Card dis-hover>
      <PriceTable v-if="CurrentRule.Price_rules_ID" :Datacolumns="Datacolumns" :Datalist="DatalistDto" @NewBuildHandleClick="NewBuildHandleClick"
      @DeletePriceData="DeletePriceData"
      @BatchHandleClick="BatchHandleClick"/>
      <Page :total="total" show-sizer show-elevator transfer style="text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
    </Card>
    <PriceModal :Modallist="Modallist" @SubmitHandleClick="SubmitHandleClick" v-if="Modallist.ModalShow"/>

    <Drawer
            title="价格批量修改"
            v-model="BatchDrawer"
            width="80"
            :mask-closable="false"
            :styles="styles"
        >
        <BatchData v-if="BatchDrawer" :MaterialCategoryID="MaterialCategoryinfo.ClassificationID" :MaterialCategoryName="MaterialCategoryinfo.Classification"
        :Price_rules_ID="CurrentRule.Price_rules_ID"
        @PriceRuleSelectHandleClick="PriceRuleSelectHandleClick2"/>
    </Drawer>
  </div>
</template>

<script>
import { MaterialCategory1 } from '../../../api/Materiel'
import { PriceRulesList, PriceData, PriceModalSelectionData, InsertPriceModalData, DeletePriceModalData } from '../../../api/PriceRules'
import MaterialCategorylist from './component/MaterialCategorylist.vue'
import PriceRules from './component/PriceRulesList.vue'
import PriceTable from './component/PriceTable.vue'
import PriceModal from './component/PriceModal.vue'
import BatchData from './component/BatchData.vue'
export default {
  name: 'PriceEntry',
  components: {
    MaterialCategorylist,
    PriceRules,
    PriceTable,
    PriceModal,
    BatchData
  },
  computed: {
    total: function () {
      return this.Datalist.length
    },
    DatalistDto: function () {
      let list = []
      for (let i = this.pageSize * (this.CurrentPage - 1); i < this.Datalist.length && i < this.pageSize * this.CurrentPage; ++i) {
        list.push(this.Datalist[i])
      }
      return list
    }
  },
  data () {
    return {
      MaterialCategorylist: [],
      RulesList: [],
      MaterialCategoryinfo: {
        IconUrl: '',
        ClassificationID: '',
        Classification: '',
        unit: ''
      },
      CurrentRule: {
        Price_rules_ID: '',
        Price_rulesName: '',
        Remarks: ''
      },
      Datacolumns: [],
      Datalist: [],
      Modallist: {
        ModalShow: false,
        isloading: true,
        info: {
          price: 0,
          datalist: []
        }
      },
      BatchDrawer: false,
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      CurrentPage: 1,
      pageSize: 10
    }
  },
  mounted: function () {
    this.GetMaterialCategoryData()
  },
  methods: {
    GetMaterialCategoryData () {
      MaterialCategory1().then(res => {
        if (res.IsSuccess) {
          this.MaterialCategorylist = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 大类被选择后回调
    MaterialCategorySelectHandleClick (item) {
      this.MaterialCategoryinfo = item
      this.CurrentRule = {
        Price_rules_ID: '',
        Price_rulesName: '',
        Remarks: ''
      }
      this.GetPriceRulesList(item.ClassificationID) // 获取价格规则
    },
    // 获取价格规则
    GetPriceRulesList (ClassificationID) {
      PriceRulesList(ClassificationID).then(res => {
        if (res.IsSuccess) {
          this.RulesList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 规则选择后回调
    PriceRuleSelectHandleClick (item) {
      this.CurrentRule = item
      PriceData(item.Price_rules_ID).then(res => {
        if (res.IsSuccess) {
          this.Datacolumns = res.Data.Table1
          this.Datacolumns.push({ // 增加操作列
            title: '操作',
            slot: 'action',
            width: 80,
            align: 'center'
          })
          this.Datalist = res.Data.Table2
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 调价后回调
    PriceRuleSelectHandleClick2 (PriceRulesID) {
      PriceData(PriceRulesID).then(res => {
        if (res.IsSuccess) {
          this.Datalist = res.Data.Table2
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 组件点击新增按钮后回调
    NewBuildHandleClick () {
      PriceModalSelectionData(this.CurrentRule.Price_rules_ID).then(res => {
        if (res.IsSuccess) {
          this.Modallist.ModalShow = true
          this.Modallist.info.price = 0
          this.Modallist.info.datalist = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击确认按钮后回调
    SubmitHandleClick (info, b) {
      if (!b) {
        this.Modallist.isloading = false
        this.Modallist.ModalShow = false
        let list = []
        for (let i = 0; i < info.datalist.length; ++i) {
          list.push(info.datalist[i].value)
        }
        InsertPriceModalData({
          price: info.price,
          Price_rules_ID: this.CurrentRule.Price_rules_ID,
          valuelist: list
        }).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '提交成功'
            })
            PriceData(this.CurrentRule.Price_rules_ID).then(res => {
              if (res.IsSuccess) {
                this.Datacolumns = res.Data.Table1
                this.Datacolumns.push({ // 增加操作列
                  title: '操作',
                  slot: 'action',
                  width: 150,
                  align: 'center'
                })
                this.Datalist = res.Data.Table2
                this.Modallist.ModalShow = false
              } else {
                this.$Message.error(res.Message)
                this.Modallist.ModalShow = false
              }
            })
          } else {
            this.$Message.error(res.Message)
            this.Modallist.ModalShow = false
          }
        })
      } else {
        this.Modallist.isloading = true
        setTimeout(() => {
          this.Modallist.isloading = false
        }, 2000)
        this.$Message.error('Fail!')
      }
    },
    // 删除数据
    DeletePriceData (index) {
      DeletePriceModalData(this.Datalist[index].dispose_id).then(res => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.Datalist.splice(index, 1)
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击批量修改按钮回调
    BatchHandleClick (value) {
      this.BatchDrawer = value
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.CurrentPage = 1
      }
    }
  }
}
</script>
<style scoped>
.icon{
  align-items: center
}
</style>
